<script setup lang="ts">
import type { JournalListItem } from '~/utils/solr/journal'
import ArticleCard from '~/components/journals/ArticleCard.vue'

const props = defineProps<{
  issue: JournalListItem
}>()

const allArticles = computed(() => {
  const lederId = props.issue.leder?.id
  const articles = (props.issue.articles || []).filter(a => a.id !== lederId)
  return [
    ...(props.issue.leder ? [props.issue.leder] : []),
    ...articles,
  ]
})
</script>

<template>
  <div>
    <h2 class="text-lg pb-2xs flex items-baseline gap-2xs">
      <span>Volum {{ issue.volume }}</span>
      <span aria-hidden="true" class="text-xl">|</span>
      <span>Utgave {{ issue.issue }}</span>
    </h2>
    <h3 class="text-base font-normal">
      {{ issue.year }}
    </h3>

    <ul class="flex flex-col">
      <li v-for="article in allArticles" :key="article.id" class="border-b border-carbon-200 p-2xs">
        <ArticleCard
          :article="article"
          :issue-number="issue.issue"
          :publisher-id="issue.publisherId"
          :volume="issue.volume"
        />
      </li>
    </ul>
  </div>
</template>
